import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = {
    class: "order-list-body",
    "data-cy": "list-control-body"
};
import { ref, onBeforeUnmount, computed, onMounted, watch, watchEffect, } from 'vue';
import { addEventList, removeEventList, } from '@/eventBus';
import { eventBusEvent, mapControl, } from '@/constants';
import OrderList from '@/views/ListControl/OrderList.vue';
import WorkerWrapper from '@/views/ListControl/WorkerWrapper.vue';
import SubController from '@/views/ListControl/SubController.vue';
// import WorkerAllocate from '@/views/Dialog/WorkerAllocate/index.vue';
import ModalWorkerInfo from '@/views/MapControl/Dialog/ModalWorkerInfo.vue';
import AllocationAlert from '@/components/AllocationAlert.vue';
import vuexStore from '@/vuex-store';
import { orderStatusGroupList } from '@/constants/listControl';
import { orderPushHandlerList } from '@/lib/list-control/handlePushOrder';
import { handlePushFulfillment } from '@/lib/list-control/handlePushFulfillment';
import WebSocketMapControl from '@/helpers/WebSocketMapControl';
import shareDelaySecondController from '@/lib/map-control/share-delay-second/shareDelaySecondController';
import { listControlActionType } from '@/vuex-store/list-control/actions';
import ContextMenu from '@/views/ListControl/ContextMenu.vue';
import { allocationControllerActionType } from '@/vuex-store/allocation-controller/actions';
import AllocationController from '@/components/AllocationController.vue';
/**
 * 초기화 꼬임 해결
 * 허브는 유저정보로 조회하고
 * 타허브권한이나 총판은 허브조회 후 조회된다.
 * 해당 케이스를 처리하기 위해 처리 플래그를 둔다.
 */
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        let isBoot = false;
        orderPushHandlerList.shareDelaySecondController = shareDelaySecondController;
        const unwatchSubscribeHubIds = ref(() => { });
        const socket = ref(null);
        const subscribeHubInfo = computed(() => vuexStore.state.hubSelector.subscribeHubInfo);
        const isDistUser = computed(() => vuexStore.getters['user/isDistUser']);
        const distributorId = computed(() => vuexStore.getters['user/distributorId']);
        const isPermissionOtherHub = computed(() => vuexStore.getters['user/isPermissionOtherHub']);
        const selectedOrderFilter = computed(() => vuexStore.state.listControl.selectedOrderFilter);
        const isOpenWorkerList = computed(() => vuexStore.state.listControl.toggleWorkerList);
        watchEffect(() => {
            const value = vuexStore.state.listControl.selectedWorker;
            vuexStore.dispatch(allocationControllerActionType.setWorker, value);
        });
        watchEffect(() => {
            const value = vuexStore.state.listControl.selectedOrderItemsObj;
            vuexStore.dispatch(allocationControllerActionType.setOrderList, value);
        });
        /**
         * 닫기 버튼 핸들러
         */
        vuexStore.dispatch(allocationControllerActionType.setOnCloseAction, () => {
            vuexStore.dispatch(listControlActionType.clearSelectedOrderItems);
            vuexStore.dispatch(listControlActionType.setSelectedWorker);
        });
        /**
         * 주문 리스트 초기화
         */
        const getOrderList = () => {
            const { id: selectedHubSelectorId, type, } = subscribeHubInfo.value[0];
            // 구동대상허브
            let subscribeTargetId = selectedHubSelectorId;
            // 총판 유저 => 총판 선택시 => 총판 단위 관제
            if (isDistUser.value
                && type === mapControl.DIST
                && selectedHubSelectorId === distributorId.value) {
                subscribeTargetId = null;
            }
            // 총판 x, 타허브권한 x => 일반 허브 유저는 허브코드 없어도 본인 허브만 조회 됨.
            if (!isDistUser.value
                && !isPermissionOtherHub) {
                subscribeTargetId = null;
            }
            return vuexStore.dispatch(listControlActionType.getOrderList, subscribeTargetId);
        };
        /**
         * 풀필먼트 조회
         */
        const getFulfillment = () => {
            const { type, } = subscribeHubInfo.value[0];
            const param = {
                distributorId: distributorId.value,
                subscribeHubId: subscribeHubInfo.value[0].id,
            };
            // 총판 유저가 총판 구독시 => 총판 단위 관제
            if (isDistUser
                && type === mapControl.DIST) {
                param.subscribeHubId = null;
            }
            return vuexStore.dispatch(listControlActionType.getFulfillment, param);
        };
        /**
         * 주문 필터 클릭 핸들러
         * @param filterId 사용자가 선택한 필터 아이디
         */
        const handleClickOrderFilter = (filterId = orderStatusGroupList.ALL.code) => {
            let selectedFilterList = selectedOrderFilter.value;
            const maxLengthWithoutAll = Object.keys(orderStatusGroupList).length - 1;
            // 전체 클릭시
            if (filterId === orderStatusGroupList.ALL.code) {
                selectedFilterList = [
                    orderStatusGroupList.ALL.code,
                ];
                vuexStore.dispatch(listControlActionType.setOrderFilter, selectedFilterList);
                return;
            }
            selectedFilterList = selectedFilterList.filter((id) => id !== orderStatusGroupList.ALL.code);
            // 추가 or 제거
            if (selectedFilterList.includes(filterId)) {
                selectedFilterList = selectedFilterList.filter((id) => id !== filterId);
            }
            else {
                selectedFilterList.push(filterId);
            }
            // 0 이거나 max면 전체만 활성
            if (selectedFilterList.length === maxLengthWithoutAll
                || selectedFilterList.length === 0) {
                selectedFilterList = [
                    orderStatusGroupList.ALL.code,
                ];
            }
            // 최종값 셋팅
            vuexStore.dispatch(listControlActionType.setOrderFilter, selectedFilterList);
        };
        /**
         * 주문 검색
         * @param 주문 검색어
         */
        const handleClickOrderSearch = (query) => {
            vuexStore.dispatch(listControlActionType.inputSearchOrderQuery, query);
        };
        const bindEvents = () => {
            const eventMapper = {
                [eventBusEvent.ListControl_handleClickOrderSearch]: handleClickOrderSearch,
                [eventBusEvent.ListControl_handleClickOrderFilter]: handleClickOrderFilter,
                [eventBusEvent.Socket_handlePushOrder]: orderPushHandlerList
                    .handlePushOrder.bind(orderPushHandlerList),
                [eventBusEvent.Socket_handlePushFulfillment]: handlePushFulfillment,
            };
            addEventList(eventMapper);
        };
        const unbindEvents = () => {
            const eventMapper = [
                eventBusEvent.ListControl_handleClickOrderSearch,
                eventBusEvent.ListControl_handleClickOrderFilter,
                eventBusEvent.Socket_handlePushOrder,
            ];
            removeEventList(eventMapper);
        };
        /**
         * 초기화
         * 소켓, API등
         */
        const init = () => {
            if (subscribeHubInfo.value.length === 0) {
                return;
            }
            isBoot = true;
            const token = vuexStore.state.auth.accessToken;
            socket.value = new WebSocketMapControl({
                token,
            });
            socket.value.setSubscribeInfo(subscribeHubInfo.value);
            socket.value.init();
            socket.value.getSocket().on('connect', () => {
                socket.value.unsubscribe();
                socket.value.subscribe();
                getOrderList();
                getFulfillment();
            });
        };
        /**
         * 일시정지 해제
         */
        watch(() => vuexStore.state.listControl.isStop, (v) => {
            // 일시정지
            if (v === true) {
                socket.value.unsubscribe();
                socket.value.disconnect();
                isBoot = false;
                return;
            }
            // 일시정지 해제
            if (v === false) {
                init();
            }
        });
        /**
         * 구독 허브 변경시 init 진행
         */
        watch(() => vuexStore.state.hubSelector.subscribeHubInfo, (v, ov) => {
            if (!isBoot) {
                init();
                return;
            }
            // mounted와 중복호출 되기 때문에 이전 값이 설정 안되어 있는 경우엔 return
            if (ov.length === 0) {
                return;
            }
            init();
        });
        onMounted(() => {
            bindEvents();
            init();
        });
        onBeforeUnmount(() => {
            unbindEvents();
            unwatchSubscribeHubIds.value();
            if (socket.value) {
                socket.value.unsubscribe();
                socket.value.disconnect();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" 주문 영역 "),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(SubController),
                    _createCommentVNode(" 배달 목록 "),
                    _createVNode(OrderList)
                ]),
                _createCommentVNode(" 라이더 영역 "),
                (isOpenWorkerList.value)
                    ? (_openBlock(), _createBlock(WorkerWrapper, {
                        key: 0,
                        class: "worker-list-body"
                    }))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" [다이얼로그] 라이더 배차 "),
                _createCommentVNode(" <WorkerAllocate></WorkerAllocate> "),
                _createCommentVNode(" [다이얼로그] 라이더 상세 "),
                _createVNode(ModalWorkerInfo),
                _createCommentVNode(" 배차 결과 우상단 노티피케이션"),
                _createVNode(AllocationAlert),
                _createCommentVNode(" 우클릭 메뉴 "),
                _createVNode(ContextMenu),
                _createCommentVNode(" [다이얼로그] 배차 컨트롤러 "),
                _createVNode(AllocationController)
            ]));
        };
    }
});
